import { FC } from 'react';

import { WarningMessageBox as Error } from '@xing-com/crate-entity-pages-common';

type AboutUsErrorPageProps = {
  refetch: () => void;
};
export const AboutUsErrorPage: FC<AboutUsErrorPageProps> = ({ refetch }) => {
  return (
    <div data-testid={'errorContainer'}>
      <Error
        headerText="EP_ERROR_HEADER"
        bodyText="EP_ERROR_BODY"
        buttonText="EP_ERROR_RELOAD_CTA"
        onClick={() => refetch()}
      />
    </div>
  );
};
